<div class="px-3">

    <div class="rem-text-default mb-6">
      <div class="flex align-items-end">

        <div class="rem-bg-light px-3 py-3 mr-2">
          <i class="pi pi-users font-medium text-xl"></i>
        </div>
        <div>
          <div class="text-2xl font-medium">QFund Discrepancies</div>
          <div class="text-right mt-2">View QFund discrepancies of creditors</div>
        </div>
        
      </div>
    </div>


    <div class="flex justify-content-between">
        <div class="flex flex-row gap-3">
            <p-multiSelect [options]="creditors"
                           [(ngModel)]="selectedCreditors"
                           placeholder="Select Creditors"
                           optionLabel="CompanyName"
                           filterBy="CreditorId,CompanyName">
                <ng-template let-creditor pTemplate="item">
                    <div class="flex align-items-center justify-content-between flex-1">
                        <div>{{ creditor.CompanyName }}</div>
                        <div class="ml-2">{{ creditor.CreditorId }}</div>
                    </div>
                </ng-template>
            </p-multiSelect>
            <p-floatLabel>
                <p-calendar id="startDate"
                            [(ngModel)]="startDate"
                            [readonlyInput]="true" />
                <label for="startDate">From Date</label>
            </p-floatLabel>
            <remitter-button (click)="search()"
                             label='Get'
                             icon='search'>
            </remitter-button>
        </div>

      
    </div>

    <div class="mt-4">
      <div 
      *ngIf="!hasTableData && hasClickedSearch"
        style="text-align:center; margin-top:9rem; color: #336699; font-size: 1rem;">
                      🚫 No records found for {{ creditorCompanyNames }}
        </div>

      <p-table
          *ngIf="hasTableData"
          [value]="transactions" [paginator]="true"
                                            [rows]="5"
                                            [tableStyle]="{ 'min-width': '50rem' }"
                                            [rowsPerPageOptions]="[5, 10, 20]">
          <ng-template pTemplate="header">
              <tr class="text-xs">
                  <th>Account Payment Id</th>
                  <th>Amount</th>
                  <th>Transaction Correlation Id</th>
                  <th>Transaction Id</th>
                  <th>Proccessed On</th>
                  <th>Paid On</th>
                  <th>Action</th>               
              </tr>
          </ng-template>
          <ng-template pTemplate="body" let-transaction>
              <tr class="text-xs">
                  <td>{{ transaction.accountPaymentId }}</td>
                  <td>{{ transaction.amount }}</td>
                  <td>{{ transaction.transactionCorrelationId }}</td>
                  <td>{{ transaction.transactionId }}</td>       
                  <td>{{ transaction.processedOn }}</td>       
                  <td>{{ transaction.paidOn }}</td>     
                  <td>
                      <div class="flex align-items-center">
                          <icon-button
                            pTooltip='Manual Sync'                            
                            (click)="manualSync(transaction)"
                            icon="sync"
                            [styleClass]="'mr-1'"
                          />                          
                        </div>
                  </td>       
              </tr>
          </ng-template>
      </p-table>
    </div>

</div>




